<template>
	<div>
		<h2>Sistema de Monitoreo Remoto</h2>
		<br>
			<div v-if="loading">
				<v-progress-circular indeterminate  color="primary" class="prg-2"/>
				<span>Cargando...</span>
			</div>
			<div v-else>
				<div class="monitoring_box" v-for="(item, i) in items" :key="i">
					<div>
						<div>
							<div>
							<a :href="item.detail" target="_blank">
								<img :src="item.image_url"/>
							</a>
							</div>
						</div>
						<div>{{item.nombre}}</div>
						<table>
							<tr>
								<th>ACC</th>
								<th>SG</th>
								<th>DIST</th>
							</tr>
							<tr>
								<td>{{item.acelerometros}}</td>
								<td>{{item.straing}}</td>
								<td>{{item.distanciometer}}</td>
							</tr>
						</table>
						<div>
							<!-- Estado: {{item.state}} -->
							<div class="monitoring_box_icons">
								<div v-for="(icon,ii) in icons" :key="ii">
									<div
										:class="[(item.lamp_connection && icon.val=='wifi' && 'active') || (item.lamp_color==icon.lamp_color && 'active')]"
										:style="`background-color:${icon.color}`" :title="icon.text">
										<v-icon color="white">{{icon.val=='panorama_fish_eye' && item.lamp_color==icon.lamp_color?'circle':icon.val}}</v-icon>
									</div>
								</div>
							</div>
						</div>
						<div>
							<a :href="item.detail" target="_blank">
								<v-btn color="primary" class="btn-radius">Ver más</v-btn>
              </a>
						</div>
					</div>
				</div>
			</div>
			
	</div>
	<!-- <SimpleCrud
    :beforeSetRows="beforeSetRows"
		:headers="headers"
		:name="c_name"
		:config_name="rq_name"
		:scheme="{}"
		:canDetail="false"
		:canDelete="false"
		:canAdd="false"
		:preFilters.sync="preFilters">
		<template slot="crud-title">Activos con monitoreo habilitado</template>
		<template slot="btns">
			<refresh-rq :name="rq_name"/>
			<v-btn color="primary" @click="open_dialog('add_monitoring_critical_asset');">Incorporar Activo Crítico</v-btn>
			<fs1-dialog id="add_monitoring_critical_asset" title="Incorporar Activo Crítico">
				<template v-slot:body>
					<in-rq-ac :value.sync="selectedItem" :obj_val.sync="ca_obj" style="text-align:left"/>
				</template>
				<template v-slot:footer="{close}">
					<v-btn color="primary" :disabled="!selectedItem" @click="add">Continuar</v-btn>
					<v-btn color="secondary" @click="close">Cancelar</v-btn>
				</template>
			</fs1-dialog>
		</template>
		<template v-slot:actions="{ item, itemDetail }">
      <td>
				<v-icon @click="itemDetail(item)">description</v-icon>
				<v-icon @click="online_monitoring_detail(item)">remove_red_eye</v-icon>
			</td>
    </template>
		<template slot="detail-header"><b></b></template>
		<template v-slot:detail="{ selectedItem }">
			<AssetResume :data="selectedItem" type="CA"/>
		</template>
	</SimpleCrud> -->
</template>

<script>
import AssetResume from '@/components/criticalAsset/AssetResume.vue';

export default {
	components:{AssetResume},
	data() {
		return {
			loading:true,
			items:[],
			icons:[
				{val:'panorama_fish_eye',color:'#007bff',text:'Conectado, sin información'},
				{val:'circle',color:'#28a745',text:'Activo operando con normalidad',lamp_color:'green'},
				{val:'panorama_fish_eye',color:'#ffc107',text:'Activo en 80% de capacidad definida',lamp_color:'yellow'},
				{val:'panorama_fish_eye',color:'#dc3545',text:'Activo en estado crítico',lamp_color:'red'},
				{val:'wifi',color:'#007bff',text:'Conexión activa'},
			],
			colors:['#007bff','#28a745','#ffc107','#dc3545'],
			/* ca_obj:{},
			selectedItem:null,
    	headers: [
				{ text: '', value: 'actions' },
				{ text: 'Organización', value: 'organization_name' },
				{ text: 'Activo / Equipo', value: 'name' },
				{ text: 'TAG Equipo', value: 'tag' },
				{ text: 'Functional location', value: 'functional_locations_str' },
				{ text: 'Modo de Falla Catastrófico', value: 'mfl_event' },
				{ text: 'Áreas Impactadas', value: 'impacted_areas_names' },
				{ text: 'Estándar', value: 'standard_name' },
				{ text: 'Cálculo de MFL Financiero', value: 'computed_financial_mfl'},
    	],
			preFilters:{is_deleted: false},
			rq_name: 'online_monitoring/critical_asset', */
		}
	},
	computed:{
		/* organizations() { return this.$store.getters.organizations },
		standards() { return this.$store.getters.standards },
		c_name(){ return this.pre_name? `${this.pre_name}-${this.rq_name}`: this.rq_name }, */
	},
	created(){
		this.loading=true;
		this.requests.getsSimple['sgs_online_monitoring/get_overview']()
			.then(r=> r.length && (this.items = r) && (this.loading=false))
	},
	methods:{
		/* beforeSetRows(items){
			items.forEach(item => {
				item.standard_name = fN(this.standards, item.standard);
				item.organization_name = (this.organizations.find(f=>f.id === item.organization)||{}).name;
				item.impacted_areas_names = inpAreasNames(item.impacted_areas);
				item.functional_locations_str = this.j(item.functional_locations.map(m=>m.functional_location));
			});
			return items;
		},
		online_monitoring_detail(item) { this.$router.push({name: 'monitoring/detail', params: { critical_asset: item.id, name: item.name}}) },
		add() {
			this.close_dialog('add_monitoring_critical_asset');
			this.online_monitoring_detail(this.ca_obj);
			this.selectedItem = null;
		} */
	}
};
</script>
<style scoped>
.monitoring_box{
	display: inline-block;
	border: solid thin gainsboro;
	border-radius: 3px;
	margin: 1px;
	padding-bottom: 12px;
}
.monitoring_box>div{
	/* width: 350px; */
}
.monitoring_box>div>*:nth-child(n+2){
	margin-top: 12px;
}
.monitoring_box img{
	width: inherit;
	vertical-align: middle;
}
.monitoring_box img:hover{
	cursor: pointer;
}
.monitoring_box>div>div:nth-of-type(1){
	width: inherit;
	padding: 5px 7px 5px 7px;
}
.monitoring_box>div>div:nth-of-type(1):hover{
	background-color: #6c757d;
}
.monitoring_box>div>div:nth-of-type(1)>div{
	width: 350px;
}
.monitoring_box>div>div:nth-of-type(2){
	text-align: center;
	font-weight: bolder;
	padding: 0 7px 0 7px;
}
.monitoring_box>div>div:nth-of-type(3){
	font-weight: bolder;
	padding: 0 7px 0 7px;
}
.monitoring_box table{
	padding: 0 7px 0 7px;
	width: 100%;
	border-spacing: 0;
}
.monitoring_box table th{
	color: white;
	padding: 3px;
	background-color: black;
}
.monitoring_box table td{
	text-align: center;
	font-weight: bolder;
	padding: 3px;
	background-color: rgb(235, 235, 235);
}
.theme--dark .monitoring_box table td{
	color: black;
}
.monitoring_box a{
	text-decoration: none;
	width: inherit;
}
.monitoring_box button{
	margin: 0 !important;
	font-weight: bolder;
	width: 100%;
}
.monitoring_box_icons{
	background-color: rgb(232, 232, 232);
	border-radius: 20px;
	padding: 5px;
	text-align: center;
}
.monitoring_box_icons>div{
	display: inline-block;
	vertical-align: middle;
}
.monitoring_box_icons>div>div{
	width: 40px;
	border-radius: 40px;
	text-align: center;
	opacity: 0.3;
	transform: scale(0.8);
}
@keyframes createBox {

  0% { transform: scale(0.7)}
  50% { transform: scale(1.1)}
  100% { transform: scale(0.7)}
}
.monitoring_box_icons>div>div.active{
	opacity: 1;
  animation-name: createBox;
  animation-duration: 2s;
  animation-iteration-count: infinite;
  -webkit-animation-name: createBox;
  -webkit-animation-duration: 2s;
  -webkit-animation-iteration-count: infinite;
  animation: createBox 2s infinite;
}
.monitoring_box_icons>div>div i{
	font-size: 18px;
	vertical-align: sub;
}

.monitoring_box_icons>div:nth-child(n+1) {
	margin-right: 10px;
}

.lamp_color.green{ background-color: #28a745;}
.lamp_color.yellow{ background-color: #ffc107;}
.lamp_color.red{ background-color: #dc3545;}
</style>
